// src/app/services/share.service.ts
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';  // ← Correct import here!

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  private platformId = inject(PLATFORM_ID);


  async share(title: string, text: string, url: string): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      // Running on server (SSR) → skip or handle differently
      return;
    }

    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        console.log('Shared successfully');
      } catch (err) {
        console.error('Share failed:', err);
        this.fallbackCopyToClipboard(url);
      }
    } else {
      this.fallbackCopyToClipboard(text);
    }
  }

  private fallbackCopyToClipboard(url: string): void {
    // Same as before...
    navigator.clipboard.writeText(url)
      .then(() => alert('Link copied to clipboard!'))
      .catch(() => alert('Could not copy: ' + url));
  }
}